// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: linear-gradient(135deg, #0b3d36, #092927);
    color: white;
    font-family: 'Arial', sans-serif;
    text-align: center;
  }
  
  .page-not-found .content {
    max-width: 600px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    background: rgba(0, 0, 0, 0.4);
  }
  
  .page-not-found h1 {
    font-size: 5em;
    margin: 0;
    color: #05755c;
  }
  
  .page-not-found h2 {
    font-size: 2em;
    margin: 10px 0;
  }
  
  .page-not-found p {
    font-size: 1.2em;
    margin: 20px 0;
  }
  
  .page-not-found .home-button {
    display: inline-block;
    padding: 10px 20px;
    font-size: 1em;
    color: white;
    background-color: #05755c;
    border: none;
    border-radius: 5px;
    text-decoration: none;
    transition: background-color 0.3s;
  }
  
  .page-not-found .home-button:hover {
    background-color: #05755c;
  }
  `, "",{"version":3,"sources":["webpack://./src/component/layouts/PageNotFound/PageNotFound.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,qDAAqD;IACrD,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".page-not-found {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background: linear-gradient(135deg, #0b3d36, #092927);\n    color: white;\n    font-family: 'Arial', sans-serif;\n    text-align: center;\n  }\n  \n  .page-not-found .content {\n    max-width: 600px;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\n    background: rgba(0, 0, 0, 0.4);\n  }\n  \n  .page-not-found h1 {\n    font-size: 5em;\n    margin: 0;\n    color: #05755c;\n  }\n  \n  .page-not-found h2 {\n    font-size: 2em;\n    margin: 10px 0;\n  }\n  \n  .page-not-found p {\n    font-size: 1.2em;\n    margin: 20px 0;\n  }\n  \n  .page-not-found .home-button {\n    display: inline-block;\n    padding: 10px 20px;\n    font-size: 1em;\n    color: white;\n    background-color: #05755c;\n    border: none;\n    border-radius: 5px;\n    text-decoration: none;\n    transition: background-color 0.3s;\n  }\n  \n  .page-not-found .home-button:hover {\n    background-color: #05755c;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
